import { DialogActions, DialogContent, styled } from "~/common/mui";
import { STICKY_TO_BOTTOM } from "../icon/Elevation";

export const DrawerHeader = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const DrawerContent = styled(DialogContent)({
  padding: "16px",
});

export const DrawerActions = styled(DialogActions)({
  padding: "8px 16px",
  boxShadow: STICKY_TO_BOTTOM,
  zIndex: 1,
});
